import { useCallback, useEffect, useState } from "react";
import { FileWarning, Settings2, ChevronDown } from "lucide-react";
import { api } from "../../lib/api";
import { RequiredDocsDialog } from "./RequiredDocsDialog";

export const MissingDocsCard = ({ canManage, onPickEmployee }) => {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(null);
  const [cfg, setCfg] = useState(false);
  const load = useCallback(() => api.requiredDocsMissing().then(setD).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  if (!d || (!d.configured && !canManage)) return null;
  return (
    <div className="rounded-2xl border border-orange-200 bg-orange-50/60 p-4" data-testid="missing-docs-card">
      <div className="flex flex-wrap items-center gap-2">
        <FileWarning className="h-5 w-5 text-orange-600" />
        <p className="font-bold text-orange-900">الوثائق الأساسية الناقصة {d.configured && <span className="font-mono-nums" data-testid="missing-docs-total">({d.total_missing})</span>}</p>
        {canManage && <button onClick={() => setCfg(true)} className="ms-auto flex items-center gap-1 rounded-lg bg-white px-2.5 py-1 text-xs font-semibold text-slate-700 shadow-sm hover:bg-slate-50" data-testid="missing-docs-settings"><Settings2 className="h-3.5 w-3.5" /> تحديد الوثائق الأساسية</button>}
      </div>
      {!d.configured ? <p className="mt-1 text-xs text-slate-600">حدّد الوثائق الإلزامية (مثل تحديث البيانات، المخالصة، سند لأمر) لكل نوع عقد ليظهر هنا من ينقصه.</p> : (
        <div className="mt-2 space-y-1.5">
          {d.items.map((it) => (
            <div key={it.id} className="rounded-xl bg-white" data-testid={`missing-doc-${it.id}`}>
              <button onClick={() => setOpen(open === it.id ? null : it.id)} className="flex w-full items-center gap-2 px-3 py-2 text-start text-sm">
                <b className="flex-1 text-slate-800">{it.label}</b>
                <span className="text-[11px] text-slate-400">{it.contract_types?.length ? it.contract_types.join("، ") : "كل الموظفين"}</span>
                <span className={`rounded-full px-2 py-0.5 text-xs font-bold ${it.missing_count ? "bg-rose-100 text-rose-700" : it.applicable ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-500"}`}>{it.missing_count ? `${it.missing_count} من ${it.applicable} ناقص` : it.applicable ? "مكتمل" : "لا ينطبق على أحد"}</span>
                {it.missing_count > 0 && <ChevronDown className={`h-4 w-4 text-slate-400 transition-transform ${open === it.id ? "rotate-180" : ""}`} />}
              </button>
              {open === it.id && it.missing_count > 0 && (
                <div className="flex flex-wrap gap-1.5 border-t border-slate-100 px-3 py-2">
                  {it.missing.map((m) => <button key={m.id} onClick={() => onPickEmployee?.(m)} className="rounded-full bg-slate-100 px-2.5 py-0.5 text-xs text-slate-700 hover:bg-blue-100" data-testid={`missing-emp-${m.id}`}>{m.name}{m.branch ? ` · ${m.branch}` : ""}</button>)}
                  {it.missing_count > it.missing.length && <span className="text-xs text-slate-400">+{it.missing_count - it.missing.length}</span>}
                </div>)}
            </div>))}
        </div>)}
      <RequiredDocsDialog open={cfg} onOpenChange={setCfg} onSaved={load} />
    </div>
  );
};
